var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('MeasureListWidget',{attrs:{"list-config-key":"measures","dialog-route-name":_vm.dialogRouteName},on:{"updated:number-of-measures":function($event){_vm.numberOfMeasures = $event;
      _vm.updateBreadCrumbs();}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }